<div class="wrapper-select-topics-and-artist-page">
  <div class="content-select-topics-and-artist">
    <div class="back-btn" [routerLink]="[PAGES_AND_PATHS.selectTopics.pagePath]">
      <img src="../assets/icons/icon-arrow-left.svg" alt="">
    </div>
    <h1>{{'SETUP_SCREEN.connect_with_trending_listers' | translate}}</h1>
    <h6>
      {{'SETUP_SCREEN.get_inspired' | translate}}
    </h6>
    <div class="wrapper-content-select-artist" (scroll)="onScroll($event)">
      <div class="wrapper-custom-checkbox-select-artist">
        <label *ngFor="let lister of listers">
          <input type="checkbox" name="radioname" [(ngModel)]="lister.selected" (change)="onSelectListerChange(lister)">
          <div class="custom-checkbox-select-artist">
            <div class="check-artist">
              <img src="../assets/icons/outline/icon-check.svg" alt="">
            </div>
            <div class="wrapper-select-artist-info">
              <div class="wrapper-image-info-artist">
                <img *ngIf="!lister?.profile_photo_url" [src]="(lister?.subscriptions | checkActiveRole) === UserRoles.expert ? '../../../assets/images/avatar-user-expert.png' : '../../../assets/images/avatar-user.png'" alt="">
                <img *ngIf="lister?.profile_photo_url" [src]="lister?.profile_photo_url" alt="">
              </div>
              <span class="text-name length-character">{{lister.name ? lister.name : lister.username}}</span>
              <span class="text-followers">{{ lister.followers_count }} {{'NEW_TEXT.followers' | translate}}</span>
            </div>
          </div>
        </label>
      </div>
    </div>
    <button (click)="onClickToContinue()" class="custom-btn custom-btn--primary xs-mt-12">
      <span>{{'GENERAL.continue' | translate}}</span>
    </button>
    <div class="wrapper-label-gray">
      <span>{{'SETUP_SCREEN.you_may_want_to_follow_some_of_trending_listers_or_you_can_skip_this_step' | translate}}</span>
    </div>
  </div>
</div>

